import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    // Budget app must always serve latest UI without manual hard-refresh.
    navigator.serviceWorker
      .getRegistrations()
      .then((registrations) =>
        Promise.all(
          registrations.map((registration) => registration.unregister()),
        ),
      )
      .then(() => {
        if (!("caches" in window)) return;
        return caches
          .keys()
          .then((cacheNames) =>
            Promise.all(
              cacheNames
                .filter((name) => name.startsWith("sslg-budget-"))
                .map((name) => caches.delete(name)),
            ),
          );
      })
      .catch((error) => {
        console.error("Service worker cleanup failed:", error);
      });
  });
}
